import { render, staticRenderFns } from "./collectingData.vue?vue&type=template&id=1b7ae443&scoped=true&"
import script from "./collectingData.vue?vue&type=script&lang=js&"
export * from "./collectingData.vue?vue&type=script&lang=js&"
import style0 from "./collectingData.vue?vue&type=style&index=0&id=1b7ae443&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7ae443",
  null
  
)

export default component.exports